import fetch from "cross-fetch";

import {getBigDataApiPath} from "../../../../../utils/get_big_data_api_path";

export const setCookies = async () => await fetch(`${getBigDataApiPath()}cookies/`, {credentials: "include"});
